import React from 'react';
import { useAuth } from '../context/AuthContext.js';
import { Navigate } from 'react-router-dom';

// This component protects routes for regular users
export function ProtectedRoute({ children }) {
  const { currentUser } = useAuth();
  if (!currentUser) {
    // If no user is logged in, redirect them to the login page
    return <Navigate to="/login" />;
  }
  return children;
}

// This component protects routes for admins
export function AdminRoute({ children }) {
  const { currentUser } = useAuth();
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  if (currentUser.role !== 'admin') {
    // If user is not an admin, redirect them to their user dashboard
    return <Navigate to="/dashboard" />;
  }
  return children;
}

